/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

/*
 * Using this json only for 18F brand.
 */

const data = {
    'ships-two-day': {
        title: 'Express two-day shipping is included on this gift.',
        expressCopy: 'Only standard shipping and processing charges will apply.',
        note: 'To avoid weekend transit, orders placed after 10AM PT / 1 PM ET on Wednesday will ship on Monday of the following week.',
    },
    'ships-overnight': {
        title: 'Express overnight shipping is included on this gift.',
        expressCopy: 'Only standard shipping and processing charges will apply.',
        note: 'To avoid weekend transit, orders placed after 10AM PT / 1 PM ET on Thursday will ship on Monday of the following week.',
    },
};
export default data;
